<template>
    <b-container fluid class="d-flex flex-column w-100 h-100 px-2">
        <b-row v-for="section in form.Sections" v-bind:key="section.Name" class="p-3 m-0">
            <b-col class="m-0">
                <!-- Section "Localisation" -->
                <b-card v-if="section.Name == 'Localization'" no-body class="p-3">
                    <b-form-group label-cols="12"
                                  label-cols-lg="12"
                                  label-class="font-weight-bold text-dark pt-0 pb-2"
                                  label-align-sm="left"
                                  label-size="lg"
                                  class="m-0"/>
                    <slot name="label">
                        <legend
                            class="text-sm-left font-weight-bold col-form-label col-form-label-lg text-dark pt-0 pb-2 col-form-label bv-no-focus-ring">
                            <b-icon icon="map" class="pr-1"/>
                            {{ section.Label }}
                        </legend>
                    </slot>
                    <!-- Construit la liste de champs -->
                    <Fields :ParentFormName="form.Name" :Fields.sync="section.Fields" v-bind:ConsultMode="ConsultMode"/>
                    <!-- Construit les tableaux -->
                    <TableDisplaying v-for="table in section.Fields.filter(x => x.Type ===  fieldTypeEnum.Table)"
                                     v-bind:key="table['Name']"
                                     :ObjectType="ObjectType"
                                     :TitleTable="table['Label']" v-bind:Headers="table.Headers"
                                     v-bind:Rows="table.Value"/>
                </b-card>
                <!-- Section "Autres Localisations" -->
                <b-card v-if="section.Name == 'OtherLocalization'" no-body class="p-3">
                    <b-form-group label-cols="12"
                                  label-cols-lg="12"
                                  label-class="font-weight-bold text-dark pt-0 pb-2"
                                  label-align-sm="left"
                                  label-size="lg"
                                  class="m-0"/>
                    <slot name="label">
                        <legend
                            class="text-sm-left font-weight-bold col-form-label col-form-label-lg text-dark pt-0 pb-2 col-form-label bv-no-focus-ring">
                            <b-icon icon="map"/>
                            {{ section.Label }}
                        </legend>
                    </slot>
                    <b-row>
                        <b-col>
                            <b-button-toolbar v-if="ConsultMode !== objectDisplayingModeEnum.Read" key-nav
                                              :aria-label="$t('ToolbarButtons')">
                                <b-button-group class="pt-1 pb-1">
                                    <b-button v-b-tooltip.hover :title="$t('AddLocation')"
                                              @click="displayModal(undefined)" variant="outline-secondary"
                                              class="btn-circle-small">
                                        <b-icon icon="plus"/>
                                    </b-button>
                                </b-button-group>
                            </b-button-toolbar>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-card v-for="table in section.Fields.filter(x => x.Type === fieldTypeEnum.Table)"
                                    :key="table['Name']"
                                    no-body class="w-100">
                                <b-card-header header-tag="header" header-bg-variant="secondary"
                                               class="text-center text-white font-weight-bold pt-0 pb-0" role="tab">
                                    {{ table['Label'] }}
                                </b-card-header>
                                <!-- Tableau des Autres localisations -->
                                <b-table striped bordered hover small tbody-tr-class="p-0" class="m-0"
                                         :fields="convertHeaders(table['Headers'])" :items="table['Value']">
                                    <template #head()="data">
                                        <div class="text-center">{{ data.label }}</div>
                                    </template>

                                    <!-- Section contenant les boutons de mise-à-jour et suppression d'une ligne d'Autres localisation -->
                                    <template #cell(remove)="row">
                                        <div class="text-center">
                                            <b-button size="sm" pill variant="outline-secondary"
                                                      class="text-center p-0 m-0 border-0"
                                                      @click="remove(row.item.CoordinateId)">
                                                <font-awesome-icon icon="x"/>
                                            </b-button>
                                        </div>
                                    </template>
                                    <template #cell(edit)="row">
                                        <div class="text-center">
                                            <b-button size="sm" pill variant="outline-secondary"
                                                      class="text-center p-0 m-0 border-0"
                                                      @click="displayModal(row.item)">
                                                <font-awesome-icon icon="pen"/>
                                            </b-button>
                                        </div>
                                    </template>
                                </b-table>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card v-if="section.Name == 'Location'" no-body class="p-3">
                    <b-form-group :label="section.Label"
                                  label-cols="12"
                                  label-cols-lg="12"
                                  label-class="font-weight-bold text-dark pt-0 pb-2"
                                  label-align-sm="left"
                                  label-size="lg"
                                  class="m-0"/>
                    <!-- Construit la liste de champs -->
                    <Fields :ParentFormName="form.Name" :Fields.sync="section.Fields" v-bind:ConsultMode="ConsultMode"/>
                    <!-- Construit les tableaux -->
                    <!--<TableDisplaying v-for="table in section.Fields.filter(x => x.Type ===  fieldTypeEnum.Table)" v-bind:key="table.Name" :TitleTable="table.Label" v-bind:Headers="table.Headers" v-bind:Rows="table.Value" />-->
                </b-card>
                <b-card v-if="section.Name == 'Address'" no-body class="p-3">
                    <b-form-group :label="section.Label"
                                  label-cols="12"
                                  label-cols-lg="12"
                                  label-class="font-weight-bold text-dark pt-0 pb-2"
                                  label-align-sm="left"
                                  label-size="lg"
                                  class="m-0"/>
                    <!-- Construit la liste de champs -->
                    <Fields :ParentFormName="form.Name" :Fields.sync="section.Fields" v-bind:ConsultMode="ConsultMode"/>
                    <!-- Construit les tableaux -->
                    <!--<TableDisplaying v-for="table in section.Fields.filter(x => x.Type ===  fieldTypeEnum.Table)" v-bind:key="table.Name" :TitleTable="table.Label" v-bind:Headers="table.Headers" v-bind:Rows="table.Value" />-->
                </b-card>
            </b-col>
        </b-row>
        <b-modal id="localizationModal" ref="localizationModal" v-model="displayLocModal" centered>
            <template #modal-header="{ }">
                <h6>
                    <b-icon icon="map" class="pr-1"/>
                    {{ $t('OtherLocations') }}
                </h6>
            </template>
            <b-form>
                <b-form-group :label="$t('Name')"
                              label-cols-sm="4"
                              label-for="otherLocNameSystem"
                              label-class="py-1"
                              label-align-sm="left">
                    <b-input-group id="otherLocNameSystem">
                        <b-form-input type="text"
                                      :required="true"
                                      :state="nameSystemState"
                                      v-model="otherLocNameSystem"/>
                    </b-input-group>
                </b-form-group>

                <b-form-group label="X"
                              label-cols-sm="4"
                              label-for="otherLocX"
                              label-class="py-1"
                              label-align-sm="left">
                    <b-input-group id="otherLocX">
                        <!-- step="0.00000000001" permet d'autoriser les valeurs décimales dans un input de type 'number' -->
                        <b-form-input type="number"
                                      :required="true"
                                      :state="xState"
                                      v-model="otherLocX"
                                      step="0.00000000001"/>
                    </b-input-group>
                </b-form-group>

                <b-form-group label="Y"
                              label-cols-sm="4"
                              label-for="otherLocY"
                              label-class="py-1"
                              label-align-sm="left">
                    <b-input-group id="otherLocY">
                        <!-- step="0.00000000001" permet d'autoriser les valeurs décimales dans un input de type 'number' -->
                        <b-form-input type="number"
                                      :required="true"
                                      :state="yState"
                                      v-model="otherLocY"
                                      step="0.00000000001"/>
                    </b-input-group>
                </b-form-group>

                <b-form-group label="Z"
                              label-cols-sm="4"
                              label-for="otherLocZ"
                              label-class="py-1"
                              label-align-sm="left">
                    <b-input-group id="otherLocZ">
                        <!-- step="0.00000000001" permet d'autoriser les valeurs décimales dans un input de type 'number' -->
                        <b-form-input type="number"
                                      :required="true"
                                      :state="zState"
                                      v-model="otherLocZ"
                                      step="0.00000000001"/>
                    </b-input-group>
                </b-form-group>
            </b-form>
            <template #modal-footer="{ cancel }">
                <!-- Cancel : Annuler -->
                <b-button @click="cancel()" variant="outline-secondary" pill>{{ $t('Cancel') }}</b-button>
                <!-- Validate : Valider -->
                <b-button @click="modifyMode ? update() : add()" variant="secondary" pill>{{ $t('Validate') }}
                </b-button>
            </template>
        </b-modal>
    </b-container>
</template>

<script lang="ts">
import {Component, Prop, PropSync, Vue, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";
import TableDisplaying from "@/components/commons/TableDisplaying.vue";
import Fields from "@/components/commons/Fields.vue";
import FormDraft from "@/types/fields/FormDraft";
import FieldTypeEnum from "@/enums/fields/FieldTypeEnum";
import TableHeader from "@/types/fields/TableHeader";
import ObjectDisplayingModeEnum from "@/enums/ObjectDisplayingModeEnum";
import TableField from "@/types/fields/TableField";
import Section from "@/types/fields/Section";
import FormField from "@/types/fields/FormField";
import IFormField from "@/interfaces/IFormField";
import ISection from "@/interfaces/ISection";
import {BaseObjectForm} from "./BaseObjectForm";
import locales from "./locales/Localization.json";
import TreeNode from "@/types/TreeNode";

/** Composant de gestion des données géographique pour la fiche objet */
@Component({
    components: {
        Fields,
        TableDisplaying
    },
    i18n: {messages: locales}
})
export default class Localization extends BaseObjectForm {
    /** Pour pouvoir utiliser les enums dans la section template */
    private fieldTypeEnum = FieldTypeEnum;
    private objectDisplayingModeEnum = ObjectDisplayingModeEnum;

    //#region Fenêtre modale de saisie d'un point d'une autre localisation
    private displayLocModal: boolean = false;
    private otherLocCoordinateId: string = "";
    private otherLocNameSystem: string = "";
    private otherLocX: number = 0;
    private otherLocY: number = 0;
    private otherLocZ: number = 0;
    private modifyMode: boolean = false;
    //#endregion Fenêtre modale de saisie d'un point d'une autre localisation
    //#region Validation fenêtre modale
    private nameSystemState = null;
    private xState = null;
    private yState = null;
    private zState = null;

    //#endregion Validation fenêtre modale

    /**  Obtient le dernier Id d'objet temporaire disponible */
    @Getter('ObjectStore/GetTempObjectId')
    private tempObjectId!: number;

    /**
     * Convertie un TableHeader en header compatible avec le Bootstrap Vue.js b-Table utilisé dans ce composant
     * @param headers: Liste de TableHeader à convertir
     * @todo: fonction également présente dans Events.vue ==> A mettre qq part pour qu'elle soit commune dans un fichiers utils.ts ou tableUtils.ts ?
     *  */
    private convertHeaders(headers: TableHeader[]) {
        let tab = headers.map(o => {
            return {key: o.Name, label: o.Label, sortable: true, thStyle: {}};
        });

        if (this.ConsultMode !== ObjectDisplayingModeEnum.Read) {	// Si on est en mode édition
            // Ajout d'une colonne Remove pour placer le bouton Remove
            tab.unshift({key: "remove", label: "", sortable: false, thStyle: {width: "10px"}});

            // Ajout d'une colonne Edit pour placer le bouton Edit
            tab.push({key: "edit", label: "", sortable: false, thStyle: {width: "10px"}});
        }
        // let objId = { key: "CoordinateId", label: "CoordinateId", sortable: false, thStyle: {} };
        // tab.push(objId);

        return tab;
    }

    /** Affichage de la fenêtre modal d'édition d'un point d'une autre localisation */
    private displayModal(item: OtherLocPoint) {
        if (item) {
            this.modifyMode = true;
            this.otherLocCoordinateId = item.CoordinateId;
            this.otherLocNameSystem = item.NameSystem;
            this.otherLocX = item.X;
            this.otherLocY = item.Y;
            this.otherLocZ = item.Z;
        } else {
            this.modifyMode = false;
            this.otherLocNameSystem = "";
            this.otherLocX = 0;
            this.otherLocY = 0;
            this.otherLocZ = 0;
        }
        this.displayLocModal = true;
    }

    private add() {
        /** Réserve un nouvel Id d'objet temporaire */
        this.$store.dispatch("ObjectStore/SetTempObjectId").then(response => {
            console.debug("Localization - add()");
            let newLoc: OtherLocPoint = {
                CoordinateId: this.tempObjectId.toString(),
                NameSystem: this.otherLocNameSystem,
                X: this.otherLocX,
                Y: this.otherLocY,
                Z: this.otherLocZ
            };

            let section: ISection | undefined = this.form.Sections.find(x => x.Name === "OtherLocalization");
            if (section) {
                let field: TableField | undefined = (section.Fields as TableField[]).find(x => x.Name === 'Points');
                if (field)
                    field.Value.push(newLoc);
            }

            this.displayLocModal = false;
        })
            .catch(err => {
                console.error(err);
                this.$bvToast.toast(this.$t('AnErrorOccured').toString(), { // Une erreur s'est produite.
                    title: this.$t('Error').toString(), // Erreur
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            });
    }

    private update() {
        this.displayLocModal = false;
        console.debug("Localization - this.otherLocSystemId : " + this.otherLocCoordinateId);

        //Recherche section "Autres Localisations"
        let section: ISection | undefined = this.form.Sections.find(x => x.Name === "OtherLocalization");
        if (section) {
            let field: TableField | undefined = (section.Fields as TableField[]).find(x => x.Name === 'Points');
            if (field) {
                let loc: OtherLocPoint | undefined = (field.Value as OtherLocPoint[]).find(x => x.CoordinateId == this.otherLocCoordinateId);
                if (loc) {
                    // Mise à jour de la localisation
                    loc.NameSystem = this.otherLocNameSystem;
                    loc.X = this.otherLocX;
                    loc.Y = this.otherLocY;
                    loc.Z = this.otherLocZ;
                }
            }
        }
    }

    private remove(id: string) {
        this.$bvModal.msgBoxConfirm(this.$t('DeletePointConfirmation').toString(), {
            title: this.$t('Suppression point').toString(),
            okVariant: 'danger',
            okTitle: this.$t('Yes').toString(),
            cancelTitle: this.$t('No').toString(),
            hideHeaderClose: false,
            centered: true
        }).then(value => {
            if (value) {
                let section: ISection | undefined = this.form.Sections.find(x => x.Name === "OtherLocalization");
                if (section) {
                    let field: FormField | undefined = (section.Fields as FormField[]).find(x => x.Name === 'Points');
                    if (field) {
                        let locIndex: number = (field['Value'] as OtherLocPoint[]).findIndex(x => x.CoordinateId == id);

                        if (locIndex)
                            field['Value'].splice(locIndex, 1);
                    }
                }
            }
        });
    }
}

/** Type de gestion d'un point d'une autre localisation */
interface OtherLocPoint {
    CoordinateId: string;
    NameSystem: string;
    X: number;
    Y: number;
    Z: number;
}
</script>

<style scoped>

</style>